<template>
  <EpecDialog
    :dialogTitle="dialogTitle"
    :centerDialogVisible="visible"
    :showBtn="false"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
    :popupWidth="'800px'"
    :appendToBody="false"
  >
    <div class="name-block flex-between">
      <div>员工登录名：{{ userInfo.memberName }}</div>
      <div>真实姓名：{{ userInfo.realName }}</div>
    </div>

    <TableList
      ref="tableList"
      :loading="loading"
      :table-data="tableData"
      :table-label="tableLabel"
      :selection-show="false"
      :reserve-selection="false"
      @handleButton="handleButton"
      @handleSortChange="handleSortChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:index="slot">
        {{ slot.scope.$index + 1 }}
      </template>
      <template v-slot:roleSlot="slot">
        <div v-if="slot.scope.row.roleCount == 1">
          {{ slot.scope.row.roleList[0].roleName }}
        </div>
        <div
          v-if="slot.scope.row.roleCount > 1"
          class="text-blue"
          @click="handleUserRole(slot.scope.row)"
        >
          拥有 {{ slot.scope.row.roleCount }} 角色
        </div>
        <div v-if="slot.scope.row.roleCount == 0">
          暂无角色
        </div>
      </template>
    </TableList>
    <div class="pagination">
      <el-pagination
        class="flex-center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[5, 10, 20, 30, 40, 50, 60, 80, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="productTagPage.currentPage"
        :page-size="productTagPage.pageSize"
        pager-count="5"
        :total="productTagPage.pageTotal"
        prev-text="上一页"
        next-text="下一页"
      >
      </el-pagination>
    </div>
  </EpecDialog>
</template>

<script>
import EpecDialog from "../../../../components/common/epecDialog";
import TableList from "../../components/common/e-table-list";
import authorityApi from "../../api/authority/index";
export default {
  name: "addUser",
  components: {
    EpecDialog,
    TableList,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    userInfo: {
      type: Object,
    },
  },
  data() {
    return {
      dialogTitle: "角色列表",
      loading: false,
      tableData: [],
      tableLabel: [
        { label: "序号", param: "roleId", align: "center" },
        { label: "角色名称", param: "roleName", align: "center" },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
      USER_INFO: {},
    };
  },
  computed: {},
  created() {
    this.queryUserRolePage();
    let USER_INFO = this.$store.state.USERINFO;
    this.USER_INFO = USER_INFO;
  },
  methods: {
    async queryUserRolePage() {
      this.loading = true;
      let query = {
        memberId: this.userInfo.memberId,
        pageSize: this.productTagPage.pageSize,
        pageStart: this.productTagPage.currentPage,
      };
      let info = await authorityApi.queryUserRolePage(query);
      this.tableData = info.data.list;
      this.productTagPage.pageTotal = info.data.total;
      this.loading = false;
    },
    updateVisible() {},
    resetPopupData() {
      this.$emit("close");
    },
    submitPopupData() {
      this.$emit("getNode", this.currentNode);
      this.$emit("close");
    },

    handleButton() {},
    handleSortChange() {},
    handleSelectionChange() {},
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      this.queryUserRolePage();
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      this.queryUserRolePage();
    },
  },
};
</script>

<style scoped>
.name-block {
  margin-bottom: 20px;
}
.flex-center {
  display: flex;
  justify-content: center;
  justify-items: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
